export const styles = theme =>({
    root: {
        width: '100%',
        // marginTop: theme.spacing.unit * 1,
    },
    table: {
    },
    tableWrapper: {
        overflowX: 'auto',
        overflowY: 'auto',
        // height: '70vh'
    },
    contentWrapper: {
        height: '100%',
    },
    margin: {
        height: 56,
        marginLeft: theme.spacing.unit,
        padding: 8,
    },
    grid:{
        borderRight: "2px solid grey",
    },   
});


// WEBPACK FOOTER //
// ./src/components/CSS/RoutineStyles.js